export const datePickerStages = {
    DATE_VALUE: "DATE_VALUE",
    PICK_DATE: "PICK_DATE",
};
